const PRESIGNED_QUERY_PARAMS = new Set([
  'awsaccesskeyid',
  'x-amz-signature',
  'x-amz-algorithm',
  'x-amz-credential',
]);

/**
 * Detects pre-signed storage URLs (AWS S3 and compatible services).
 * Those URLs already carry their authentication in the query string, and S3 rejects
 * requests that also send an Authorization header with
 * "InvalidArgument: Only one auth mechanism allowed".
 */
export function isPresignedStorageUrl(url: string): boolean {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const queryStart = url.indexOf('?');

  if (queryStart === -1) {
    return false;
  }

  const params = new URLSearchParams(url.slice(queryStart + 1).split('#')[0]);

  for (const key of params.keys()) {
    if (PRESIGNED_QUERY_PARAMS.has(key.toLowerCase())) {
      return true;
    }
  }

  return false;
}
